'use strict'

import Vue from 'vue'
import { numFormat } from '@/common/lib/strLib'
import store from '@/store'

Vue.filter('numFilter', function (value, fixed) {
  if (!value) return 0
  let val = (value / 1).toFixed(fixed).replace('.', '.')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('iconFilter', function (value) {
  return value ? value.toUpperCase().charAt(0) : ''
})

Vue.filter('firstStrFilter', function (value) {
  let val = ''
  if (value && value !== '') {
    const firstChar = value.charAt(0)
    const firstCharUpper = firstChar.toUpperCase()
    const leftChar = value.slice(1, value.length)
    val = firstCharUpper + leftChar
  }
  return val
})

Vue.filter('iconBackground', function (value) {
  if (value === '') return null
  let color = ['#ff464f', '#ff8a34', '#ffbc25', '#27cd8b', '#005df2', '#6952dc']
  let index = 0

  if (value && value.length > 0) {
    for (let i = 0; i < value.length; i++) {
      index += value.charCodeAt(i)
    }
  }
  return color[index % 6]
})

Vue.filter('commentFilter', function (content, cmId) {
  if (!content) return ''

  let showContent = content
  let timestamp
  let link = ''
  let replaceStr = ''

  let totalSectionList = store.getters.totalSectionList
  let mtType = store.getters.currentMt.mtType

  if (totalSectionList !== undefined && totalSectionList !== null) {
    // Section Meeting 댓글
    if (content.includes('stId:')) {
      timestamp = content.match(/ST:\S{36}\sclipId:CL:\S{36}\s\d{2}:\d{2}/g)
      for (let str in timestamp) {
        let strSplit = timestamp[str].replace('clipId:', '').split(' ')
        let sectionIndex = totalSectionList.findIndex((sectionInfo) => sectionInfo.stId === strSplit[0])

        // Section 이 없을 경우
        if (sectionIndex < 0) {
          link = '[Deleted Section' + ' ' + strSplit[2] + ']'
        } else {
          let clipList = totalSectionList[sectionIndex].clipList
          let clipIndex = -1
          if (clipList !== undefined && clipList !== null && clipList.length > 0)
            clipIndex = clipList.findIndex((clip) => clip.clipId === strSplit[1])
          // Clip 이 없을 경우
          if (clipIndex < 0) {
            link = '[Deleted Clip' + ' ' + strSplit[2] + ']'
          } else {
            let id = cmId + '_' + str
            link = `<a style='line-break: anywhere' time='${
              strSplit[2]
            }' sectionIndex= '${sectionIndex}' clipIndex='${clipIndex}' id='${id}' @click='setIndex(${sectionIndex}, ${clipIndex})'>[Clip#${numFormat(
              sectionIndex + 1
            )}-${numFormat(clipIndex + 1)} ${strSplit[2]}]</a>`
          }
        }

        replaceStr = '[stId:' + strSplit[0] + ' clipId:' + strSplit[1] + ' ' + strSplit[2] + ']'

        showContent = showContent.replace(replaceStr, link)
      }
    }
    // Chronological && 기존 댓글
    else {
      timestamp = content.match(/CL:\S{36}\s\d{2}:\d{2}/g)
      for (let str in timestamp) {
        let strSplit = timestamp[str].split(' ')

        let sectionIndex = -1

        if (mtType === 'chronological') {
          for (let section in totalSectionList) {
            if (totalSectionList[section].clipList.length > 0) {
              let isMatched = totalSectionList[section].clipList[0].clipId === strSplit[0]
              if (isMatched) {
                sectionIndex = Number.parseInt(section)
                break
              }
            }
          }
        } else {
          sectionIndex = 0
        }
        // 섹션이 없을 경우
        if (sectionIndex < 0) {
          link = '[Deleted Clip' + ' ' + strSplit[1] + ']'
        } else {
          let clipList = totalSectionList[sectionIndex].clipList
          let clipIndex = -1
          if (clipList !== undefined && clipList !== null && clipList.length > 0)
            clipIndex = clipList.findIndex((clip) => clip.clipId === strSplit[0])
          // Clip 이 없을 경우
          if (clipIndex < 0) {
            link = '[Deleted Clip' + ' ' + strSplit[1] + ']'
          } else {
            let id = cmId + '_' + str
            link = `<a style='line-break: anywhere' time='${
              strSplit[1]
            }' sectionIndex= '${sectionIndex}' clipIndex='${clipIndex}' id='${id}' @click='setIndex(${sectionIndex}, ${clipIndex})'>[Clip#${numFormat(
              mtType === 'chronological' ? sectionIndex + 1 : clipIndex + 1
            )} ${strSplit[1]}]</a>`
          }
        }
        replaceStr = '[clipId:' + strSplit[0] + ' ' + strSplit[1] + ']'
        showContent = showContent.replace(replaceStr, link)
      }
    }
    showContent = showContent.replaceAll('</br>', '\n')
    return showContent
  } else return ''
})

Vue.filter('removeHtmlFilter', function (content) {
  if (!content) return ''
  const extractTextPattern = /(<([^>]+)>)/gi
  return content.replace(extractTextPattern, '')
})
